module.exports = __webpack_public_path__ + "static/media/mobile.6d12579a.mp4";